const Skeleton = ({ className = '' }: { className?: string }) => (
    <div className={`animate-pulse bg-gray-200 dark:bg-slate-700 rounded ${className}`} />
);

const CardSkeleton = () => (
    <div className="bg-gray-50 dark:bg-slate-900 rounded-lg p-4 border border-gray-200 dark:border-slate-700">
        <Skeleton className="h-4 w-24 mb-4" />
        <div className="space-y-3">
            {[...Array(6)].map((_, i) => <Skeleton key={i} className="h-3 w-full" />)}
        </div>
    </div>
);

const VerificationConfigSkeleton = () => (
    <div className="p-6 space-y-6">
        <Skeleton className="h-6 w-96 mb-2" />
        <div className="grid grid-cols-2 gap-4">
            <CardSkeleton />
            <CardSkeleton />
        </div>
        <CardSkeleton />
        <div className="grid grid-cols-2 gap-4">
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
        </div>
    </div>
);

export default VerificationConfigSkeleton;
